/**
 * ChecklistOption — Toggleable card used for "Talent Commitments" / "Gig Requirements".
 *
 * Props:
 *   label     string
 *   checked   bool
 *   onToggle  () => void
 */
import { IconCheck } from "@tabler/icons-react";
import styles from "./jobForm.module.css";

export default function ChecklistOption({ label, checked, onToggle }) {
  return (
    <div
      className={`${styles.option} ${checked ? styles.optionChecked : ""}`}
      onClick={onToggle}
      role="checkbox"
      aria-checked={checked}
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onToggle();
        }
      }}
    >
      <div className={styles.box}>
        <IconCheck size={13} />
      </div>
      <span className={styles.label}>{label}</span>
    </div>
  );
}
